import Overlay from "./Overlay";


export default class Loading extends Overlay {
    state = {canClose: false};
}
